var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.renderCol)?_c('el-col',_vm._b({staticClass:"col-inner"},'el-col',Object.assign({}, {xs: _vm.xs, sm: _vm.sm, md: _vm.md, lg: _vm.lg, xl: _vm.xl}, _vm.$attrs),false),[_vm._t("default")],2):_c('div',[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }